import _ from 'lodash'
import React from 'react'
import { use, api } from 'xadmin'
import { DepartmentSelectField, DepartmentMultipleSelectField } from '../components/DepartmentSelect'
import SelectDepartment, { filterDepartment } from './SelectDepartment'

const DepartmentSelectComponent = (props) => {

  const { input, field, placeholder, defaultValue, multiple, treeCheckable, selectDepartment } = props
  const [ value, setValue ] = React.useState(input.value)

  React.useEffect(() => {
    setValue(defaultValue || {})
    input.onChange(defaultValue || {})
  }, [defaultValue])

  const onChange = (item) => {
    setValue(item)
    input.onChange(item)
  }

  return (
    <div>
      { multiple ? 
      <DepartmentMultipleSelectField {...props} input={{...input, value: value instanceof Array ? value : !_.isEmpty(value) ? [value] : [], onChange}} field={{...field, placeholder}} treeCheckable={treeCheckable} filterDepartment={filterDepartment} selectDepartment={selectDepartment} /> :
      <DepartmentSelectField {...props} input={{...input, value, onChange}} field={{...field, placeholder}} filterDepartment={filterDepartment} selectDepartment={selectDepartment}/>}
    </div>
  )
}

const paramSchema = {
  type: 'object',
  properties: {
    multiple: {
      type: 'boolean',
      title: '多选',
      field: {
        effect: ({ value }, form) => {
          setTimeout(() => {
            form.setFieldData('treeCheckable', { display: !!value })
          })
        }
      }
    },
    treeCheckable: {
      type: 'boolean',
      title: '复选框'
    },
    placeholder: {
      title: '提示文字',
      type: 'string',
      description: '选择器中的提示文本信息'
    },
    selectDepartment: {
      title: '选择部门',
      type: 'array',
      items: {},
      field: {
        component: SelectDepartment
      }
    }
  }
}

const DepartmentSelect = {
  title: '部门选择器',
  category: '业务选择器',
  icon: require('./../icon/部门选择器.svg'),
  component: DepartmentSelectComponent,
  paramSchema: paramSchema,
  fieldWidget: true,
  initParam: { placeholder: '请选择部门' },
  initLayout: { width: 160, height: 40 },
  theme: [
    { selector: '.ant-select .ant-select-selector', title: '选择器样式' }
  ]
}

export default DepartmentSelect
